<template>
  <section class="news">
    <h3 class="news__title">Aktuelles</h3>
    <container style="position:relative">
      <svg class="news__icon" width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1664 640q53 0 90.5 37.5t37.5 90.5-37.5 90.5-90.5 37.5v384q0 52-38 90t-90 38q-417-347-812-380-58 19-91 66t-31 100.5 40 92.5q-20 33-23 65.5t6 58 33.5 55 48 50 61.5 50.5q-29 58-111.5 83t-168.5 11.5-132-55.5q-7-23-29.5-87.5t-32-94.5-23-89-15-101 3.5-98.5 22-110.5h-122q-66 0-113-47t-47-113v-192q0-66 47-113t113-47h480q435 0 896-384 52 0 90 38t38 90v384zm-128 604v-954q-394 302-768 343v270q377 42 768 341z" fill="#fff"/></svg>
      <div class="news__content">{{ content.text }}</div>
      <div class="news__timestamp">Aus: <a :href=" content.source_link ">{{ content.source_text }}</a></div>
    </container>
  </section>
</template>

<script>
  import {api} from '@/main.js'
  import Container from "@/components/container/index";
  export default {
    name: 'OnepageNews',
    components: {Container},
    data () {
      return {
        content: false
      }
    },
    mounted () {
      api.singleton.get('news').then(response => {
        this.content = JSON.parse(response.data)
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .news {
    background: $primary;
    color: $text-inverse;

    &__title {
      text-align: center;
      font-size: $size_title-big;
      margin: $spacing_title;
    }

    &__icon {
      width: 6rem;
      height: 6rem;
      position: absolute;
      left: 0;
      top: calc(50% - 4rem);
    }
    &__content {
      padding-left: 8rem;
      font-size: $size_text-big;
      line-height: 1.3;
    }
    &__timestamp {
      margin-top: 3rem;
      text-align: center;
      font-size: $size_text-small;

      a {
        color: $text-inverse;
        font-style: normal;
      }
    }

    @media (max-width: 777px) {
      &__icon { display: none }
      &__content { padding-left: 0; text-align: justify }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/onepage/news.vue